'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ../~/dom-helpers/util/inDOM.js
 ** module id = 1309
 ** module chunks = 3
 **/